import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <Route
    key="/consumer/apps/ymk"
    element={
      <DefaultConsumerLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Consumer',
            item: '/consumer',
          },
          {
            position: 3,
            name: 'YMK',
            item: '/consumer/apps/ymk',
          },
        ]}
      />
    }
  >
    <Route path="consumer/apps/ymk" element={<AsyncPage />} />
  </Route>,
];
